import MBACoursePage from './courses/MBACoursePage';
import MCACoursePage from './courses/MCACoursePage';
import BBACoursePage from './courses/BBACoursePage';
import LLBCoursePage from './courses/LLBCoursePage';
import FashionDesigningCoursePage from './courses/FashionDesigningCoursePage';
import HotelManagementCoursePage from './courses/HotelManagementCoursePage';

import React from 'react';
import { useParams } from 'react-router-dom';
import NotFoundPage from './NotFoundPage';
import BACriminologyCoursePage from './courses/BACriminologyCoursePage';
import BAEconomicsCoursePage from './courses/BAEconomicsCoursePage';
import BAEnglishLiteratureCoursePage from './courses/BAEnglishLiteratureCoursePage';
import BAHistoryCoursePage from './courses/BAHistoryCoursePage';
import BAJournalismMassCommCoursePage from './courses/BAJournalismMassCommCoursePage';
import BAMSCoursePage from './courses/BAMSCoursePage';
import BAPhilosophyCoursePage from './courses/BAPhilosophyCoursePage';
import BAPoliticalScienceCoursePage from './courses/BAPoliticalScienceCoursePage';
import BAPublicAdministrationCoursePage from './courses/BAPublicAdministrationCoursePage';
import BASociologyCoursePage from './courses/BASociologyCoursePage';
import BATamilLiteratureCoursePage from './courses/BATamilLiteratureCoursePage';
import BCACoursePage from './courses/BCACoursePage';
import BCivilCoursePage from './courses/BCivilCoursePage';
import BComGeneralCoursePage from './courses/BComGeneralCoursePage';
import BDSCoursePage from './courses/BDSCoursePage';
import BEAeronauticalCoursePage from './courses/BEAeronauticalCoursePage';
import BEAerospaceCoursePage from './courses/BEAerospaceCoursePage';
import BEAgriculturalEngineeringCoursePage from './courses/BEAgriculturalEngineeringCoursePage';
import BEAutomobileCoursePage from './courses/BEAutomobileCoursePage';
import BEBiomedicalCoursePage from './courses/BEBiomedicalCoursePage';
import BEBiotechnologyCoursePage from './courses/BEBiotechnologyCoursePage';
import BECCECoursePage from './courses/BECCECoursePage';
import BECeramicCoursePage from './courses/BECeramicCoursePage';
import BEChemicalCoursePage from './courses/BEChemicalCoursePage';
import BECSEAIMLCoursePage from './courses/BECSEAIMLCoursePage';
import BECSECyberSecurityCoursePage from './courses/BECSECyberSecurityCoursePage';
import BECSEDataScienceCoursePage from './courses/BECSEDataScienceCoursePage';
import BEdCoursePage from './courses/BEdCoursePage';
import BEECECoursePage from './courses/BEECECoursePage';
import BEECEVLSICoursePage from './courses/BEECEVLSICoursePage';
import BEECoursePage from './courses/BEECoursePage';
import BEElectronicsEngineeringCoursePage from './courses/BEElectronicsEngineeringCoursePage';
import BEElectricalComputerCoursePage from './courses/BEElectricalComputerCoursePage';
import BEEnvironmentalCoursePage from './courses/BEEnvironmentalCoursePage';
import BEFoodTechnologyCoursePage from './courses/BEFoodTechnologyCoursePage';
import BEGeoInformaticsCoursePage from './courses/BEGeoInformaticsCoursePage';
import BEIndustrialCoursePage from './courses/BEIndustrialCoursePage';
import BEInstrumentationCoursePage from './courses/BEInstrumentationCoursePage';
import BELeatherCoursePage from './courses/BELeatherCoursePage';
import BEManufacturingCoursePage from './courses/BEManufacturingCoursePage';
import BEMarineCoursePage from './courses/BEMarineCoursePage';
import BEMechatronicsCoursePage from './courses/BEMechatronicsCoursePage';
import BEMedicalElectronicsCoursePage from './courses/BEMedicalElectronicsCoursePage';
import BEMiningCoursePage from './courses/BEMiningCoursePage';
import BEPetroleumCoursePage from './courses/BEPetroleumCoursePage';
import BEPlasticCoursePage from './courses/BEPlasticCoursePage';
import BEProductionCoursePage from './courses/BEProductionCoursePage';
import BERoboticsCoursePage from './courses/BERoboticsCoursePage';
import BETelecommunicationCoursePage from './courses/BETelecommunicationCoursePage';
import BETextileCoursePage from './courses/BETextileCoursePage';
import BEVLSICoursePage from './courses/BEVLSICoursePage';
import BHMSCoursePage from './courses/BHMSCoursePage';
import BMechCoursePage from './courses/BMechCoursePage';
import BNYSCoursePage from './courses/BNYSCoursePage';
import BPharmCoursePage from './courses/BPharmCoursePage';
import BPTCoursePage from './courses/BPTCoursePage';
import MPharmCoursePage from './courses/MPharmCoursePage';
import MPTCoursePage from './courses/MPTCoursePage';
import PharmDCoursePage from './courses/PharmDCoursePage';
import BScChemistryCoursePage from './courses/BScChemistryCoursePage';
import BScComputerScienceCoursePage from './courses/BScComputerScienceCoursePage';
import BScMathematicsCoursePage from './courses/BScMathematicsCoursePage';
import BScPhysicsCoursePage from './courses/BScPhysicsCoursePage';
import BTechAgriculturalCoursePage from './courses/BTechAgriculturalCoursePage';
import BTechAICoursePage from './courses/BTechAICoursePage';
import BTechCSBSCoursePage from './courses/BTechCSBSCoursePage';
import BTechElectronicsVLSICoursePage from './courses/BTechElectronicsVLSICoursePage';
import BTechFashionTechnologyCoursePage from './courses/BTechFashionTechnologyCoursePage';
import BTechITCoursePage from './courses/BTechITCoursePage';
import BUMSCoursePage from './courses/BUMSCoursePage';
import BVScCoursePage from './courses/BVScCoursePage';
import DiplomaCivilEngineeringCoursePage from './courses/DiplomaCivilEngineeringCoursePage';
import DiplomaComputerEngineeringCoursePage from './courses/DiplomaComputerEngineeringCoursePage';
import DiplomaElectricalEngineeringCoursePage from './courses/DiplomaElectricalEngineeringCoursePage';
import DiplomaMechanicalEngineeringCoursePage from './courses/DiplomaMechanicalEngineeringCoursePage';
// Allied Health Sciences
import OptometryCoursePage from './courses/OptometryCoursePage';
import MicroBiologyCoursePage from './courses/MicroBiologyCoursePage';
import ClinicalNutritionCoursePage from './courses/ClinicalNutritionCoursePage';
import MedicalLabTechnologyCoursePage from './courses/MedicalLabTechnologyCoursePage';
import RadiographyCoursePage from './courses/RadiographyCoursePage';
import PhysicianAssistantCoursePage from './courses/PhysicianAssistantCoursePage';
import OperationTheatreTechnologyCoursePage from './courses/OperationTheatreTechnologyCoursePage';
import RadiotherapyTechnologyCoursePage from './courses/RadiotherapyTechnologyCoursePage';
import EmergencyCareCoursePage from './courses/EmergencyCareCoursePage';
import AudiologySpeechPathologyCoursePage from './courses/AudiologySpeechPathologyCoursePage';
import CardiovascularTechnologyCoursePage from './courses/CardiovascularTechnologyCoursePage';
import ProstheticsOrthoticsCoursePage from './courses/ProstheticsOrthoticsCoursePage';
import FitnessLifestyleCoursePage from './courses/FitnessLifestyleCoursePage';
import NeuroElectroPhysiologyCoursePage from './courses/NeuroElectroPhysiologyCoursePage';
import MedicalSociologyCoursePage from './courses/MedicalSociologyCoursePage';
import NuclearMedicineTechnologyCoursePage from './courses/NuclearMedicineTechnologyCoursePage';
import RespiratoryTherapyCoursePage from './courses/RespiratoryTherapyCoursePage';
import CardiacTechnologyCoursePage from './courses/CardiacTechnologyCoursePage';
import DialysisTechnologyCoursePage from './courses/DialysisTechnologyCoursePage';
import MedicalRecordScienceCoursePage from './courses/MedicalRecordScienceCoursePage';
import CriticalCareTechnologyCoursePage from './courses/CriticalCareTechnologyCoursePage';
// courses subfolder
import BSCNursingCoursePage from './courses/BSCNursingCoursePage';
import BTechCSECoursePage from './courses/BTechCSECoursePage';
import MBBSCoursePage from './courses/MBBSCoursePage';
import BSMSCoursePage from './courses/BSMSCoursePage';
import BScAgricultureCoursePage from './courses/BScAgricultureCoursePage';
import MScAgricultureCoursePage from './courses/MScAgricultureCoursePage';
import MedCoursePage from './courses/MedCoursePage';

const COURSE_PAGE_MAP: Record<string, React.ComponentType> = {
  'ba-criminology': BACriminologyCoursePage,
  'ba-economics': BAEconomicsCoursePage,
  'ba-english-literature': BAEnglishLiteratureCoursePage,
  'ba-history': BAHistoryCoursePage,
  'ba-journalism-mass-comm': BAJournalismMassCommCoursePage,
  'ba-ms': BAMSCoursePage,
  'bams': BAMSCoursePage,
  'ba-philosophy': BAPhilosophyCoursePage,
  'ba-political-science': BAPoliticalScienceCoursePage,
  'ba-public-administration': BAPublicAdministrationCoursePage,
  'ba-sociology': BASociologyCoursePage,
  'ba-tamil-literature': BATamilLiteratureCoursePage,
  'bba': BBACoursePage,
  'mba': MBACoursePage,
  'mca': MCACoursePage,
  'llb': LLBCoursePage,
  'bca': BCACoursePage,
  'be-civil': BCivilCoursePage,
  'bcom-general': BComGeneralCoursePage,
  'bds': BDSCoursePage,
  'be-aeronautical': BEAeronauticalCoursePage,
  'be-aerospace': BEAerospaceCoursePage,
  'be-agricultural-engineering': BEAgriculturalEngineeringCoursePage,
  'be-automobile': BEAutomobileCoursePage,
  'be-biomedical': BEBiomedicalCoursePage,
  'be-biotechnology': BEBiotechnologyCoursePage,
  'be-cce': BECCECoursePage,
  'be-ceramic': BECeramicCoursePage,
  'be-chemical': BEChemicalCoursePage,
  'be-cse-aiml': BECSEAIMLCoursePage,
  'be-cse-cyber-security': BECSECyberSecurityCoursePage,
  'be-cse-data-science': BECSEDataScienceCoursePage,
  'bed': BEdCoursePage,
  'be-ece': BEECECoursePage,
  'be-ece-vlsi': BEECEVLSICoursePage,
  'be': BEECoursePage,
  'be-electronics-engineering': BEElectronicsEngineeringCoursePage,
  'be-electrical-computer': BEElectricalComputerCoursePage,
  'be-electronics-instrumentation': BEInstrumentationCoursePage,
  'fashion-designing': FashionDesigningCoursePage,
  'hotel-management': HotelManagementCoursePage,
  'be-environmental': BEEnvironmentalCoursePage,
  'be-food-technology': BEFoodTechnologyCoursePage,
  'be-geo-informatics': BEGeoInformaticsCoursePage,
  'be-industrial': BEIndustrialCoursePage,
  'be-instrumentation': BEInstrumentationCoursePage,
  'be-leather': BELeatherCoursePage,
  'be-manufacturing': BEManufacturingCoursePage,
  'be-marine': BEMarineCoursePage,
  'be-mechatronics': BEMechatronicsCoursePage,
  'be-medical-electronics': BEMedicalElectronicsCoursePage,
  'be-mining': BEMiningCoursePage,
  'be-petroleum': BEPetroleumCoursePage,
  'be-plastic': BEPlasticCoursePage,
  'be-production': BEProductionCoursePage,
  'be-robotics': BERoboticsCoursePage,
  'be-telecommunication': BETelecommunicationCoursePage,
  'be-textile': BETextileCoursePage,
  'be-vlsi': BEVLSICoursePage,
  'bhms': BHMSCoursePage,
  'bmech': BMechCoursePage,
  'bnys': BNYSCoursePage,
  'bpharm': BPharmCoursePage,
  'bpt': BPTCoursePage,
  'mpharm': MPharmCoursePage,
  'mpt': MPTCoursePage,
  'pharmd': PharmDCoursePage,
  'bsc-chemistry': BScChemistryCoursePage,
  'bsc-computer-science': BScComputerScienceCoursePage,
  'bsc-mathematics': BScMathematicsCoursePage,
  'bsc-physics': BScPhysicsCoursePage,
  'btech-agricultural': BTechAgriculturalCoursePage,
  'btech-ai': BTechAICoursePage,
  'btech-cs-bs': BTechCSBSCoursePage,
  'btech-electronics-vlsi': BTechElectronicsVLSICoursePage,
  'btech-fashion-technology': BTechFashionTechnologyCoursePage,
  'btech-it': BTechITCoursePage,
  'bums': BUMSCoursePage,
  'bvsc': BVScCoursePage,
  'diploma-civil-engineering': DiplomaCivilEngineeringCoursePage,
  'diploma-computer-engineering': DiplomaComputerEngineeringCoursePage,
  'diploma-electrical-engineering': DiplomaElectricalEngineeringCoursePage,
  'diploma-mechanical-engineering': DiplomaMechanicalEngineeringCoursePage,
  'optometry': OptometryCoursePage,
  'microbiology': MicroBiologyCoursePage,
  'clinical-nutrition': ClinicalNutritionCoursePage,
  'medical-lab-technology': MedicalLabTechnologyCoursePage,
  'radiography': RadiographyCoursePage,
  'physician-assistant': PhysicianAssistantCoursePage,
  'operation-theatre-technology': OperationTheatreTechnologyCoursePage,
  'radiotherapy-technology': RadiotherapyTechnologyCoursePage,
  'emergency-care': EmergencyCareCoursePage,
  'audiology-speech-pathology': AudiologySpeechPathologyCoursePage,
  'cardiovascular-technology': CardiovascularTechnologyCoursePage,
  'prosthetics-orthotics': ProstheticsOrthoticsCoursePage,
  'fitness-lifestyle': FitnessLifestyleCoursePage,
  'neuro-electro-physiology': NeuroElectroPhysiologyCoursePage,
  'medical-sociology': MedicalSociologyCoursePage,
  'nuclear-medicine-technology': NuclearMedicineTechnologyCoursePage,
  'respiratory-therapy': RespiratoryTherapyCoursePage,
  'cardiac-technology': CardiacTechnologyCoursePage,
  'dialysis-technology': DialysisTechnologyCoursePage,
  'medical-record-science': MedicalRecordScienceCoursePage,
  'critical-care-technology': CriticalCareTechnologyCoursePage,
  'bsc-nursing': BSCNursingCoursePage,
  'btech-cse': BTechCSECoursePage,
  'mbbs': MBBSCoursePage,
  'bsms': BSMSCoursePage,
  'bsc-agriculture': BScAgricultureCoursePage,
  'msc-agriculture': MScAgricultureCoursePage,
  'med': MedCoursePage
};

const CoursePageLoader: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  if (!slug) return <NotFoundPage />;
  const Comp = COURSE_PAGE_MAP[slug];
  if (!Comp) return <NotFoundPage />;
  return <Comp />;
};

export default CoursePageLoader;
